"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function cov_20c2q1369() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/BathroomVersionTwoFilled.tsx";
  var hash = "f60ed52fa37fec7cafd83af32fcb37837d50cadc";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/BathroomVersionTwoFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 67
        },
        end: {
          line: 11,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f60ed52fa37fec7cafd83af32fcb37837d50cadc"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_20c2q1369 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_20c2q1369();
var Icon = (cov_20c2q1369().s[0]++, {
  name: 'bathroom-version-two-filled',
  svg: "<g clip-path=\"url(#clip0_8546_22669)\">\n  <path d=\"M15.7852 2.01475C16.2188 2.44831 16.2188 3.15125 15.7852 3.58481L9.59425 9.77576C9.5192 10.6315 10.2453 11.3488 11.09 11.2781L17.284 5.08408C17.7175 4.65052 18.4205 4.65052 18.854 5.08408C19.2876 5.51764 19.2876 6.22058 18.854 6.65414L12.6703 12.8379C12.6161 13.7258 13.3634 14.4772 14.2569 14.4206L20.4382 8.23935C20.8717 7.80579 21.5747 7.80579 22.0082 8.23935C22.4418 8.67291 22.4418 9.37585 22.0082 9.80941L15.5719 16.2457C15.5604 16.2572 15.5487 16.2685 15.5368 16.2794L13.2474 18.5688C12.0026 19.8135 10.179 20.2221 8.55206 19.6837L6.38859 21.8472C5.95503 22.2808 5.25209 22.2808 4.81852 21.8472L2.43161 19.4603C1.99805 19.0267 1.99806 18.3238 2.43162 17.8902L4.5728 15.7491C3.89974 13.965 4.31405 11.916 5.69915 10.5309L6.81227 9.41774L6.8221 9.40779L14.2151 2.01475C14.6487 1.58119 15.3516 1.58119 15.7852 2.01475Z\" fill=\"currentColor\"/>\n  </g>\n  <defs>\n  <clipPath id=\"clip0_8546_22669\">\n  <rect width=\"24\" height=\"24\" fill=\"white\"/>\n  </clipPath>\n  </defs>"
});
var _default = exports["default"] = Icon;